"use strict";
/** types in this file have been hoisted to @iotv/iotv-v3-types it is recommended to import from there, this is retained for compatibility */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthNumberEnum = exports.ENG_MONTHS = exports.ENG_DAYS = exports.DayNumberEnum = void 0;
var iotv_v3_types_1 = require("@iotv/iotv-v3-types");
Object.defineProperty(exports, "DayNumberEnum", { enumerable: true, get: function () { return iotv_v3_types_1.DayNumberEnum; } });
Object.defineProperty(exports, "ENG_DAYS", { enumerable: true, get: function () { return iotv_v3_types_1.ENG_DAYS; } });
Object.defineProperty(exports, "ENG_MONTHS", { enumerable: true, get: function () { return iotv_v3_types_1.ENG_MONTHS; } });
Object.defineProperty(exports, "MonthNumberEnum", { enumerable: true, get: function () { return iotv_v3_types_1.MonthNumberEnum; } });
/** noved to @iotv/iotv-v3-types
 * search
 
import.*?(DayHour|DayNumber|MinuteNumber|MonthNumber|QuarterIdx|SecondNumber|TZ_OFFSET|WeekDayNumber|DayNumberEnum|ENG_DAYS|ENG_MONTHS|MonthNumberEnum).*?from.*?@iotv/datamodel.*?$

 *
 */
